<button
  [disabled]="disabled"
  class="flex flex-row justify-center items-center btn-primary py-4 full kiosk:text-3xl kiosk:py-6"
  [class.disabled]="disabled"
  [style.backgroundColor]="buttonBackgroundColor | contentBuilderColor"
  [style.borderColor]="buttonBackgroundColor | contentBuilderColor"
  [style.color]="buttonTextColor | contentBuilderColor"
  (click)="clickEventEmitter.emit($event)"
>
  @if (icon) {
    <i class="icon {{ icon }} pr-3 kiosk:pr-5"></i>
  }
  @if (iconUrl) {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      width="16"
      viewBox="0 0 16 16"
      class="spinner shrink-0"
      [class.mr-3]="label"
      aria-hidden="true"
    >
      <g fill="currentColor">
        <g class="spinner__circle">
          <path
            d="M8 16a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM8 2a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6z"
            opacity=".4"
          ></path>
          <path d="M8 0v2a6.006 6.006 0 0 1 6 6h2a8.009 8.009 0 0 0-8-8z"></path>
        </g>
      </g>
    </svg>
  }
  {{ label }}
</button>
